import React from 'react';
import { Box, Typography } from '@mui/material';
import { TOKENS } from '../state/colors';
import { fs } from '../state/typography';
import { TAMANOS_PAGINA, TamanoPagina } from '../state/paginacion';

interface QuoteTablePaginationProps {
  pagina: number;
  totalPaginas: number;
  filasPorPagina: TamanoPagina;
  onAnterior: () => void;
  onSiguiente: () => void;
  onCambiarTamano: (tamano: TamanoPagina) => void;
}

export const QuoteTablePagination: React.FC<QuoteTablePaginationProps> = ({
  pagina,
  totalPaginas,
  filasPorPagina,
  onAnterior,
  onSiguiente,
  onCambiarTamano,
}) => {
  const enPrimera = pagina <= 1;
  const enUltima = pagina >= totalPaginas;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px', marginTop: '16px' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <Box
          component="button"
          data-testid="quote-pagination-prev"
          onClick={onAnterior}
          disabled={enPrimera}
          sx={{
            border: `1px solid ${TOKENS.hair}`,
            backgroundColor: 'transparent',
            borderRadius: '8px',
            padding: '5px 12px',
            fontFamily: 'Poppins, sans-serif',
            fontSize: fs(12.5),
            color: enPrimera ? TOKENS.faint : TOKENS.text,
            cursor: enPrimera ? 'default' : 'pointer',
            opacity: enPrimera ? 0.5 : 1,
          }}
        >
          Anterior
        </Box>
        <Typography
          data-testid="quote-pagination-info"
          sx={{ fontFamily: 'Poppins, sans-serif', fontSize: fs(12.5), color: TOKENS.muted }}
        >
          Página {pagina} de {totalPaginas}
        </Typography>
        <Box
          component="button"
          data-testid="quote-pagination-next"
          onClick={onSiguiente}
          disabled={enUltima}
          sx={{
            border: `1px solid ${TOKENS.hair}`,
            backgroundColor: 'transparent',
            borderRadius: '8px',
            padding: '5px 12px',
            fontFamily: 'Poppins, sans-serif',
            fontSize: fs(12.5),
            color: enUltima ? TOKENS.faint : TOKENS.text,
            cursor: enUltima ? 'default' : 'pointer',
            opacity: enUltima ? 0.5 : 1,
          }}
        >
          Siguiente
        </Box>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: fs(12), color: TOKENS.muted }}>Filas por página</Typography>
        <Box
          component="select"
          data-testid="quote-pagination-size"
          value={filasPorPagina}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onCambiarTamano(Number(e.target.value) as TamanoPagina)}
          sx={{
            border: `1px solid ${TOKENS.hair}`,
            borderRadius: '8px',
            padding: '4px 8px',
            fontFamily: 'Poppins, sans-serif',
            fontSize: fs(12.5),
            color: TOKENS.text,
            backgroundColor: '#fff',
          }}
        >
          {TAMANOS_PAGINA.map((t) => (
            <option key={t} value={t}>
              {t}
            </option>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
